import { Button, Paper, Toolbar, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import Layout from '../../../common/components/Layout';
import { SimpleBreadcrumbs } from '../../../common/components/SimpleBreadcrumbs';
import { TableList } from '../../../common/components/TableList';
import { UserRestriction } from '../../../common/components/UserRestiction';
import { getProject } from '../../../common/services/project';
import { getLinkId } from '../../../common/services/tools';
import { CompetitionInput } from '../../competitions/CompetitionInput';
import MatchInput from '../../matches/Input';
import TeamInput from '../../teams/Input';
import { IComponentProps } from './MatchVideoList.connector';
import { MatchVideoRow } from './MatchVideoRow.component';

interface IState {
  // IRIs as returned by the inputs; converted to ids for the API filters.
  match: string | null;
  competition: string | null;
  team: string | null;
}

const TABLE_HEADERS = [
  { labelKey: 'field_thumbnail' },
  { labelKey: 'field_match' },
  { labelKey: 'field_title' },
  { labelKey: 'field_duration' },
  { labelKey: 'field_source' },
  { labelKey: 'field_publishedAt' },
];

export class MatchVideoList extends React.Component<IComponentProps, IState> {
  public state: IState = { match: null, competition: null, team: null };

  public componentDidMount() {
    this.fetchData();
  }

  public render() {
    const {
      matchVideos,
      fetching,
      pagination,
      total,
      intl: { messages: m },
    } = this.props;

    return (
      <Layout
        id="match-videos-layout"
        top={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <SimpleBreadcrumbs crumbStack={[{ labelKey: 'app_matchVideos' }]} />
            <UserRestriction>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.props.history.push(`${getProject().url}/match-videos/add`)}
              >
                <AddIcon style={{ marginRight: 8 }} />
                {m.button_add}
              </Button>
            </UserRestriction>
          </div>
        }
        main={
          <Paper elevation={2}>
            <Toolbar>
              <Typography variant="h6">{m.app_matchVideos}</Typography>
            </Toolbar>
            {this.renderFilters()}
            <TableList
              tableData={matchVideos}
              tableHeaders={TABLE_HEADERS}
              Row={MatchVideoRow}
              loading={fetching}
              pagination={pagination}
              total={total}
              onPaginate={this.fetchData}
            />
          </Paper>
        }
      />
    );
  }

  private renderFilters = () => {
    const { match, competition, team } = this.state;

    return (
      <div style={{ display: 'flex', gap: 16, padding: '0 16px 16px', flexWrap: 'wrap' }}>
        <div style={{ flex: 2, minWidth: 260 }}>
          <MatchInput
            input={{ name: 'match', value: match, onChange: (value: string | null) => this.updateFilter('match', value) }}
            competition={competition}
          />
        </div>
        <div style={{ flex: 1, minWidth: 220 }}>
          <CompetitionInput
            input={{ name: 'competition', value: competition, onChange: (value: string | null) => this.updateFilter('competition', value) }}
            selectedCompetitionOption={null}
          />
        </div>
        <div style={{ flex: 1, minWidth: 220 }}>
          <TeamInput
            input={{ name: 'team', value: team, onChange: (value: string | null) => this.updateFilter('team', value) }}
          />
        </div>
      </div>
    );
  };

  private updateFilter = (name: keyof IState, value: string | null) => {
    // @ts-ignore - computed key on a typed state
    this.setState({ [name]: value }, () => this.fetchData());
  };

  // FDA filters: match.id (exact), competition, team (custom filters, by id).
  private fetchData = (query: object = {}) => {
    const { match, competition, team } = this.state;
    const filters: { [key: string]: string } = {};
    if (match) filters['match.id'] = getLinkId(match);
    if (competition) filters.competition = getLinkId(competition);
    if (team) filters.team = getLinkId(team);

    this.props.fetchMatchVideos({ ...filters, ...query });
  };
}
